export default [
  [['title', 'ASC']],
  [['title', 'DESC']],
  [['brand', 'ASC']],
  [['brand', 'DESC']],
]
